export default __webpack_public_path__ + "static/media/logo.bb4fa75a.png";